export default function($scope, data, $uibModalInstance) {

	$scope.title = data.title;
	$scope.content = data.content;
	$scope.confirmText = data.confirmText;
	$scope.cancelText = data.cancelText;

	$scope.confirm = function() {
		$uibModalInstance.close();
	};

	$scope.cancel = function() {
		$uibModalInstance.dismiss();
	}
}


// WEBPACK FOOTER //
// ./app/components/dialog/dialog.js